import { useCallback } from 'react'
import { useProjektprognosEditingContext } from '../../context/ProjektprognosEditingContext'
import { useProjektprognosUser } from '../../fetchData/queries/useUser'

interface CellParams {
  node?: {
    data: {
      editable: boolean
    }
  }
  column: {
    getColId: () => string
  }
}

const useCheckIfSheetEditable = () => {
  const { readOnlyMode } = useProjektprognosEditingContext()
  const { data } = useProjektprognosUser()

  const checkIfEditable = useCallback(
    (params: CellParams): boolean => {
      const rowIsEditable: boolean = params.node?.data.editable ?? false
      const isCommentColumn = params.column.getColId() === 'comment'

      if (rowIsEditable) {
        // readonlymode used to view comments in historic sheets
        if (readOnlyMode) {
          return isCommentColumn
        } else {
          const writePermission = data?.scopes?.['sheet_write'] ?? false
          return writePermission
        }
      }

      return false
    },
    [data?.scopes, readOnlyMode]
  )

  return checkIfEditable
}

export default useCheckIfSheetEditable
